import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { kayaCRUD } from "../../../actions/kaya";
import { buildingCRUD } from "../../../actions/building";
import { selector } from "../../../api";
import { Loading } from "../../constant";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Divider, Modal, SelectPicker } from "rsuite";

const dictionarySchema = Yup.object().shape({
  head_phone_number: Yup.string().required("This field is required"),
});

export const EditKayaContent = (props) => {
  const { dataId, index, setIndex, open, setOpen } = props;

  const user = selector.User();

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [building, setBuilding] = useState([]);
  const [value, setValue] = useState("");
  const [currentBuilding, setCurrentBuilding] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      buildingCRUD
        .loadBuildingAutoComplete(10, 0, value)
        .then((resp) => {
          setBuilding(resp.data.results);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    }, 500);
  }, [value]);

  const initialValues = {
    code: "",
    head_phone_number: "",
    elecricity_meter_no: "",
    water_meter_no: "",
    house_no: "",
    postcode: "",
    distance_to_health_center: "",
    distance_to_market: "",
    distance_to_education_center: "",
    distance_to_water_source: "",
    is_toilet_available: true,
    remarks: "",
    description: "",
    edited_by: user.id,
    recorded_by: user.id,
    is_closed: false,
    building_id: null,
    building_kaya_id: null,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: dictionarySchema,
    onSubmit: (values, { setSubmitting }) => {
      const {
        code,
        head_phone_number,
        elecricity_meter_no,
        water_meter_no,
        house_no,
        postcode,
        distance_to_education_center,
        distance_to_health_center,
        distance_to_market,
        distance_to_water_source,
        is_toilet_available,
        remarks,
        description,
        building_id,
        building_kaya_id,
        is_closed,
        edited_by,
        recorded_by,
      } = values;
      const data = {
        code,
        head_phone_number,
        elecricity_meter_no,
        water_meter_no,
        house_no,
        postcode,
        distance_to_education_center,
        distance_to_health_center,
        distance_to_market,
        distance_to_water_source,
        is_toilet_available,
        remarks,
        edited_by,
      };
      const kaya_id = dataId;
      const dataBuilding = { is_closed, kaya_id, building_id, edited_by };

      setLoading(true);
      setTimeout(() => {
        kayaCRUD
          .updateKaya(dataId, data)
          .then(() => {
            if (building_kaya_id === null && building_id) {
              const kayaBuilding = {
                kaya_id,
                description,
                building_id,
                recorded_by,
              };
              kayaCRUD
                .addKayaBuilding(kayaBuilding)
                .then(() => {
                  toast.success("Kaya has been updated.", { autoClose: 7000 });
                  setIndex(index + 1);
                  setLoading(false);
                  setSubmitting(false);
                  setOpen(false);
                })
                .catch((error) => {
                  toast.error(error.message, { autoClose: 7000 });
                  setLoading(false);
                  setSubmitting(false);
                });
            } else if (building_kaya_id && building_id) {
              kayaCRUD
                .updateKayaBuilding(building_kaya_id, dataBuilding)
                .then(() => {
                  toast.success("Kaya has been updated.", { autoClose: 7000 });
                  setSubmitting(false);
                  setLoading(false);
                  setIndex(index + 1);
                  setOpen(false);
                })
                .catch((error) => {
                  toast.error(error, { autoClose: 7000 });
                  setLoading(false);
                  setSubmitting(false);
                });
            } else {
              toast.success("Kaya has been updated.", { autoClose: 7000 });
              setSubmitting(false);
              setLoading(false);
              setIndex(index + 1);
              setOpen(false);
            }
          })
          .catch((error) => {
            toast.error(error, { autoClose: 7000 });
            setLoading(false);
            setSubmitting(false);
          });
      }, 1000);
    },
  });

  useEffect(() => {
    if (!dataId || !open) return;
    setDataLoading(true);
    setTimeout(() => {
      kayaCRUD
        .loadKayaUpdate(dataId)
        .then((resp) => {
          const buildingData = resp.data.kaya_building[0]?.building_id || null;
          setCurrentBuilding(buildingData);

          formik.setValues({
            ...formik.values,
            building_id: buildingData?.id || null,
            building_kaya_id: resp.data.kaya_building[0]?.id || null,
            code: resp.data.code || "",
            head_phone_number: resp.data.head_phone_number || "",
            elecricity_meter_no: resp.data.elecricity_meter_no || "",
            water_meter_no: resp.data.water_meter_no || "",
            house_no: resp.data.house_no || "",
            postcode: resp.data.postcode || "",
            distance_to_health_center: resp.data.distance_to_health_center || "",
            distance_to_market: resp.data.distance_to_market || "",
            distance_to_education_center: resp.data.distance_to_education_center || "",
            distance_to_water_source: resp.data.distance_to_water_source || "",
            is_toilet_available: resp.data.is_toilet_available ?? true,
            remarks: resp.data.remarks || "",
          });
        })
        .finally(() => {
          setDataLoading(false);
        });
    }, 1000);
  }, [dataId, open]);

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)} size="lg">
        <Modal.Header>
          <Modal.Title>
            <i className="ri-edit-2-line me-2 text-primary"></i>Edit Household (Kaya)
          </Modal.Title>
        </Modal.Header>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {dataLoading ? (
                      <Loading />
                    ) : (
                      <div className="card-body">
                        {/* House Hold Information */}
                        <h6 className="text-primary fw-semibold mb-3"><i className="ri-information-line align-bottom me-1"></i>Household Information</h6>
                        <div className="row mb-4">
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">
                                Data collection
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Data collection code"
                                {...formik.getFieldProps("code")}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">
                                Head Phone number <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Head Phone Number"
                                {...formik.getFieldProps("head_phone_number")}
                              />
                              {formik.touched.head_phone_number &&
                                formik.errors.head_phone_number && (
                                  <div className="fw-light h6 mt-1" style={{ fontSize: "15px" }}>
                                    <span role="alert" className="text-danger">
                                      {formik.errors.head_phone_number}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">House Number</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="House Number"
                                {...formik.getFieldProps("house_no")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">Postcode</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Postcode"
                                {...formik.getFieldProps("postcode")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">Electricity Meter No.</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Electricity meter number"
                                {...formik.getFieldProps("elecricity_meter_no")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">Water Meter No.</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Water meter number"
                                {...formik.getFieldProps("water_meter_no")}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Distances now captured on the Building, not the household. */}

                        {/* Amenities */}
                        <h6 className="text-primary fw-semibold mb-3"><i className="ri-home-gear-line align-bottom me-1"></i>Amenities</h6>
                        <div className="row mb-4">
                          <div className="col-sm-12 col-md-4">
                            <div className="form-check form-switch form-switch-lg form-switch-success" dir="ltr">
                              <input
                                className="form-check-input code-switcher"
                                checked={formik.values.is_toilet_available}
                                onChange={(e) => formik.setFieldValue("is_toilet_available", e.target.checked)}
                                type="checkbox"
                                id="is_toilet_available"
                              />
                              <label className="form-check-label" htmlFor="is_toilet_available">
                                Toilet Available
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-8">
                            <div className="mb-3">
                              <label className="form-label">Remarks</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Remarks"
                                {...formik.getFieldProps("remarks")}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Building Information */}
                        <h6 className="text-primary fw-semibold mb-3"><i className="ri-building-2-line align-bottom me-1"></i>Building Link <span className="text-muted fw-normal small">(optional)</span></h6>
                        <div className="row mb-4">
                          <div className="col-sm-12 col-md-4">
                            <div className="mb-3">
                              <label className="form-label">
                                Select/Change Building
                              </label>
                              <SelectPicker
                                data={building?.map((dt) => ({
                                  value: dt.id,
                                  label: dt.name + " - " + (dt.boundary_id?.boundary_name || ""),
                                }))}
                                placeholder={currentBuilding ? `Current: ${currentBuilding.name || 'N/A'}` : "Select building"}
                                onChange={(e) => {
                                  formik.setFieldValue("building_id", e);
                                }}
                                onSearch={(e) => setValue(e)}
                                block={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-4">
                            <div className="mb-3">
                              <label className="form-label">Building Postcode</label>
                              <input
                                type="text"
                                className="form-control border-dashed"
                                value={currentBuilding?.postcode || "N/A"}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-4">
                            <div className="mb-3">
                              <label className="form-label">Building House No</label>
                              <input
                                type="text"
                                className="form-control border-dashed"
                                value={currentBuilding?.house_no || "N/A"}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">Electricity Meter No</label>
                              <input
                                type="text"
                                className="form-control border-dashed"
                                value={currentBuilding?.elecricity_meter_no || "N/A"}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="mb-3">
                              <label className="form-label">Water Meter No</label>
                              <input
                                type="text"
                                className="form-control border-dashed"
                                value={currentBuilding?.water_meter_no || "N/A"}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-2">
                            <div className="mb-3">
                              <label className="form-label">Number of Units</label>
                              <input
                                type="text"
                                className="form-control border-dashed"
                                value={currentBuilding?.number_of_units || "N/A"}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-2">
                            <div className="mb-3">
                              <label className="form-label">Number of Floors</label>
                              <input
                                type="text"
                                className="form-control border-dashed"
                                value={currentBuilding?.number_of_floors || "N/A"}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-2">
                            <div className="form-check form-switch form-switch-lg form-switch-secondary mt-4" dir="ltr">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={currentBuilding?.is_condominium || false}
                                disabled
                              />
                              <label className="form-check-label">
                                Condominium
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="card-footer">
                      <div className="d-flex justify-content-end">
                        <div className="pagination-wrap hstack gap-2">
                          <a
                            className="btn btn-light fw-medium"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(false);
                            }}
                          >
                            <i className="ri-close-line me-1 align-middle"></i> Cancel
                          </a>
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={formik.isSubmitting || !formik.isValid}
                          >
                            {!loading && (
                              <span className="indicator-label">
                                <i className="ri-save-3-line me-1 align-middle"></i> Save Changes
                              </span>
                            )}
                            {loading && (
                              <span className="indicator-progress" style={{ display: "block" }}>
                                Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                              </span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
        </form>
      </Modal>
    </>
  );
};
